import { render, staticRenderFns } from "./OverallTrends.vue?vue&type=template&id=055c1730&scoped=true&"
import script from "./OverallTrends.vue?vue&type=script&lang=js&"
export * from "./OverallTrends.vue?vue&type=script&lang=js&"
import style0 from "./OverallTrends.vue?vue&type=style&index=0&id=055c1730&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c1730",
  null
  
)

export default component.exports